import { every, _every } from "./every";

/**
 * {@inheritDoc every}
 */
export const all = every;
/**
 * {@inheritDoc _every}
 */
export const _all = _every;
